import React, {useState} from 'react';
import Customer from '../../../types/Customer';
import Button from '../../button';
import {getAttributeValue} from "../../../lib/attribute";
import DropdownField from "../../dropdown-field";
import useUserVidaAccessStatusUpdate from "../../../hooks/use-user-vida-access-status-update";

interface Props {
  customer: Customer;
}

const AdminUserVidaAccessStatusForm: React.FC<Props> = ({ customer }) => {
  const [vidaAccessStatus, setVidaAccessStatus] = useState(
    getAttributeValue(customer.attributes, 'vidaAccessStatus')
  );

  const [updating, setUpdating] = useState(false);
  const [message, setMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const update = useUserVidaAccessStatusUpdate(() => {
    setUpdating(false);
    setMessage('Updated successfully');
  }, () => {
    setUpdating(false);
    setErrorMessage('Update failed');
  });

  const onClick = () => {
    setUpdating(true);
    setMessage('');
    setErrorMessage('');
    update(customer.id, vidaAccessStatus);
  };

  return (
    <form onSubmit={(e) => {
      e.preventDefault();
    }}>
      <h2>VIDA Access Status</h2>
      <div className="vida-access-status">
        <DropdownField
          id="status"
          label="Status"
          value={vidaAccessStatus}
          options={[
            { label: '- Choose One -', value: '' },
            { label: 'Needs Approval', value: 'NEEDS_APPROVAL' },
            { label: 'Approved', value: 'APPROVED' },
            { label: 'Denied', value: 'DENIED' }]}
          onChange={(e) => setVidaAccessStatus(e.target.value)}
        />
      </div>
      {updating
        ? <p>Updating...</p>
        : <>
          <Button text="Save" onClick={onClick}/>
          {message && <p style={{ marginTop: "14px" }}>{message}</p>}
          {errorMessage && <p style={{ marginTop: "14px", color: "red" }}>{errorMessage}</p>}
        </>}
      {/* language=CSS */}
      <style jsx>{`
        .vida-access-status {
          display: flex;
          flex-wrap: wrap;
        }
      `}</style>
    </form>
  );
};

export default AdminUserVidaAccessStatusForm;
